<avi-dynamic-data-grid
    *ngIf="trafficLogsSignpostStore.logsEndToEndTimingSignpostData$ | async as logsEndToEndTimingSignpostData"
    class="logs-signpost-custom-e2e-timing-data-grid"
    [config]="logListGridConfig"
    [rows]="logsEndToEndTimingSignpostData.e2eResult"
    [rowsTotal]="logsEndToEndTimingSignpostData.e2eResult?.length"
    [isLoading]="trafficLogsSignpostStore.isLoading$ | async"
></avi-dynamic-data-grid>

<ng-template
    #nameFieldTemplateRef
    let-row
    let-index="index"
>
    <div
        *ngIf="trafficLogsSignpostStore.logSelectedSignpostConfigKey$ | async as configKey"
        class="logs-signpost-custom-e2e-timing-data-grid__content"
    >
        <span
            *ngIf="row.value.isValid"
            logFilterRange
            [property]="row.value.param"
            [start]="row.value.value.start"
            [end]="row.value.value.end"
            (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
        >
            {{ row.value.value | signpostLogDataTransform: configKey }}
        </span>
        <span
            *ngIf="!row.value.isValid"
            logFilterableEmptyField
            [property]="row.value.param"
            (onFilterAdd)="trafficLogsSignpostStore.closeSignpost()"
        ></span>
    </div>
</ng-template>

<ng-template
    #progressBarFieldTemplateRef
    let-row
    let-index="index"
>
    <avi-progress-bar
        [percentage]="row.percentage"
        [hidePercentage]="true"
    ></avi-progress-bar>
</ng-template>

<ng-template
    #percentageFieldTemplateRef
    let-row
    let-index="index"
>
    <span> {{ row.percentage + '%' }} </span>
</ng-template>
